import { useId } from 'react';
import targetPaths from '../vendor/codex-desktop/composer-target-icon.json';
import cancelPaths from '../vendor/codex-desktop/composer-cancel-icon.json';
import locale from '../vendor/codex-desktop/composer-goal-zh-CN.json';

export const GOAL_MODE_PLACEHOLDER = locale['composer.placeholder.goal'];

export interface GoalModeIndicatorProps {
  disabled?: boolean;
  /** Exits composer goal mode only; never clears an existing saved goal. */
  onClearGoal: () => void;
}

function ComposerIcon({ paths, size = 16 }: { paths: Array<{ d: string; fill?: string; 'fill-rule'?: string; 'clip-rule'?: string }>; size?: number }) {
  return <svg className="goal-mode-svg" width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
    {paths.map((path, index) => <path key={index} d={path.d}
      fill={path.fill ?? 'currentColor'}
      fillRule={path['fill-rule'] as 'nonzero' | 'evenodd' | 'inherit' | undefined}
      clipRule={path['clip-rule'] as 'nonzero' | 'evenodd' | 'inherit' | undefined} />)}
  </svg>;
}

export function GoalModeIcon({ size = 20 }: { size?: number }) {
  return <ComposerIcon paths={targetPaths} size={size} />;
}

/**
 * The composer footer indicator from the Codex desktop app.
 * Hover/focus on an active indicator swaps target-light-16 for
 * circle-xmark-fill-light-16 and exposes the installed Chinese tooltip “明确目标”.
 */
export function GoalModeIndicator({ disabled = false, onClearGoal }: GoalModeIndicatorProps) {
  const tooltipId = useId();
  return <span className="goal-mode-indicator-wrap">
    <button type="button" className="goal-mode-indicator group" data-active="true" disabled={disabled}
      aria-label="退出目标模式" aria-describedby={tooltipId} onClick={onClearGoal}>
      <span className="goal-mode-icon goal-mode-target"><ComposerIcon paths={targetPaths} /></span>
      <span className="goal-mode-icon goal-mode-cancel"><ComposerIcon paths={cancelPaths} /></span>
      <span className="goal-mode-label">目标</span>
    </button>
    <span id={tooltipId} className="goal-mode-tooltip" role="tooltip">{locale['composer.goalModeIndicator.tooltip']}</span>
  </span>;
}
